import styled from "styled-components";
import { useDolarPrice } from '../../hooks/useDolarPrice';


export default function FootPriceTable() {
    const [dolar, currentDate] = useDolarPrice()
    return (
        <StyleFootPriceTable>
            <p className='fletes'><strong>Estos precios no incluyen flete: para Córdoba 4%, Rosario 3%, Santa Fe 3%, Mendoza 6%, Corrientes 6%, Tucumán 8%, Neuquén 8%. Retiro sin cargo en planta Bs. As.</strong></p>
                    
            <div className="containerCondiciones container">
                <p>*Diametro del Rollo: 1mt (B-12 1.3 metros)</p>
                <p>{currentDate}</p>
                <p>***Cotización Dolar Oficial Venta Banco Nacion</p>
            </div>
        </StyleFootPriceTable>
    )
}

const StyleFootPriceTable = styled.div`
    .fletes{
        text-align: center;
        margin-top: 2rem;
        @media (min-width: 768px){
            margin: 0rem;
        }
    }

    .containerCondiciones{
        margin-top: 1.5rem;
        font-size: 13px;
    }
`